import styled from "styled-components";

export const CloseButton = styled.div`
	color: #fff;
	position: absolute;
	background-color: rgba(0, 0, 0, 0.25);
	background-position: 50%;
	background-size: 44px;
	height: 32px;
	right: 45px;
	top: 41px;
	width: 32px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;
